import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ApiService from './lib/rd-forms/APIService'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user: {
      username: localStorage.getItem('username') || null,
      roles: localStorage.getItem('roles') || null,
      identityProvider: localStorage.getItem('identityProvider') || null
    }
  },
  mutations: {
    auth_request(state) {
      state.status = 'loading'
    },
    auth_success(state, { token, username, roles, identityProvider }) {
      state.status = 'success'
      state.token = token
      state.user = {
        username,
        roles,
        identityProvider
      }
    },
    auth_error(state) {
      state.status = 'error'
    },
    logout(state) {
      state.status = ''
      state.token = ''
      state.user = {
        username: null,
        roles: null,
        identityProvider: null
      }
    }
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        ApiService.loginUser(user)
          .then((resp) => {
            console.log('Login response: ')
            console.log(resp.data)
            const token = resp.data.hash
            const username = resp.data.username
            const roles = resp.data.roles
            const identityProvider = resp.data.identityProvider
            localStorage.setItem('token', token)
            localStorage.setItem('username', username)
            localStorage.setItem('roles', roles)
            localStorage.setItem('identityProvider', identityProvider)
            axios.defaults.headers.common['Authorization'] = token
            commit('auth_success', { token, username, roles, identityProvider })
            resolve(resp)
          })
          .catch((err) => {
            commit('auth_error')
            localStorage.removeItem('token')
            localStorage.removeItem('username')
            localStorage.removeItem('roles')
            localStorage.removeItem('identityProvider')
            reject(err)
          })
      })
    },
    loginMicrosoft({ commit }, jwt) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        ApiService.getTokenFromMicrosoftJwt(jwt)
          .then((resp) => {
            const token = resp.data.hash
            const username = resp.data.username
            const roles = resp.data.roles
            const identityProvider = resp.data.identityProvider
            localStorage.setItem('token', token)
            localStorage.setItem('username', username)
            localStorage.setItem('roles', roles)
            localStorage.setItem('identityProvider', identityProvider)
            axios.defaults.headers.common['Authorization'] = token
            commit('auth_success', { token, username, roles, identityProvider })
            resolve(resp)
          })
          .catch((err) => {
            commit('auth_error')
            localStorage.removeItem('token')
            localStorage.removeItem('username')
            localStorage.removeItem('roles')
            localStorage.removeItem('identityProvider')
            reject(err)
          })
      })
    },
    register({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request')
        axios({
          url: 'http://localhost:3000/register',
          data: user,
          method: 'POST'
        })
          .then((resp) => {
            const token = resp.data.token
            const user = resp.data.user
            localStorage.setItem('token', token)
            axios.defaults.headers.common['Authorization'] = token
            commit('auth_success', token, user)
            resolve(resp)
          })
          .catch((err) => {
            commit('auth_error', err)
            localStorage.removeItem('token')
            reject(err)
          })
      })
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('logout')
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        localStorage.removeItem('roles')
        localStorage.removeItem('identityProvider')
        delete axios.defaults.headers.common['Authorization']
        resolve()
      })
    }
  },
  getters: {
    isLoggedIn: (state) => !!state.token,
    user: (state) => state.user,
    authStatus: (state) => state.status
  }
})
